import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, {
  forwardRef,
  useContext,
  useImperativeHandle,
  useState,
} from 'react';
import C from '../../../../../shared/constants/general';
import { PollContext } from '../../../shared/context/PollContext';
import PollInputVote from './PollInputVote';

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: 8,
    minWidth: 300,
  },
  paperBg: {
    backgroundColor: theme.palette.background.default,
  },
  dialogBg: {
    backgroundColor: 'rgba(255, 255, 255, 0.22)',
  },
}));

const pollTypes = {
  [C.POLL.TYPE.VOTE]: PollInputVote,
};
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const PollModal = (_props, ref) => {
  const classes = useStyles();
  const { actions } = useContext(PollContext);
  const [dialogState, setDialog] = useState({ open: false, poll: null });
  const [pollAnswerData, setPollAnswerData] = useState(null);

  const handleDialogClose = () => {
    setDialog({ open: false, data: null });
  };
  const handleDialogConfirm = () => {
    actions.postAnswer(dialogState.poll.id, pollAnswerData, handleDialogClose);
  };

  useImperativeHandle(ref, () => ({
    setState: (options) => {
      setDialog({ ...dialogState, ...options });
    },
  }));

  const PollInput = dialogState.poll && pollTypes[dialogState.poll.type];

  return (
    <Dialog
      open={dialogState.open}
      onClose={handleDialogClose}
      TransitionComponent={Transition}
      scroll="paper"
      keepMounted
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.dialogBg}
      PaperProps={{ className: classes.paperBg }}
    >
      {dialogState.poll && PollInput !== null && (
        <>
          <DialogTitle id="alert-dialog-title">
            {dialogState.poll.title || 'Poll'}
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <PollInput
              pollId={dialogState.poll.id}
              poll={dialogState.poll}
              dataCallback={setPollAnswerData}
            />
          </DialogContent>
        </>
      )}
      <DialogActions>
        <Button onClick={handleDialogClose} color="default">
          Cancel
        </Button>
        <Button
          onClick={handleDialogConfirm}
          color="primary"
          disabled={dialogState.pollProgress}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default forwardRef(PollModal);
